<div>
    <sh-table>
        <sh-table-row slot="header">
            @if (selectable()) {
                <sh-table-head columns="2">
                    <sh-checkbox [active]="selectAll" (checkedChange)="toggleSelectAll($event)" />
                </sh-table-head>
            }
            @for (column of columns(); track column) {
                <sh-table-head columns="{{ column.width }}" unsortable>
                    <span class="table-header-cell-text">{{ column.name }} </span>
                </sh-table-head>
            }
        </sh-table-row>
        @for (row of rows; track row) {
            <sh-table-row (click)="rowClicked(row)">
                @if (selectable()) {
                    <sh-table-cell>
                        <sh-checkbox
                            (checkedChange)="toggleSelect(row)"
                            [active]="isSelected(row, selectAll)"
                        ></sh-checkbox>
                    </sh-table-cell>
                }
                @for (column of columns(); track column) {
                    <sh-table-cell columns="{{ column.width }}">
                        @if (column.row) {
                            <div>
                                {{ column.row(row) }}
                            </div>
                        }
                        @if (column.component) {
                            <div>
                                <app-component-wrapper
                                    [component]="column.component"
                                    (componentInit)="invokeComponentInit(column, $event, row)"
                                />
                            </div>
                        }
                    </sh-table-cell>
                }
            </sh-table-row>
        }
    </sh-table>

    @if (isLoading()) {
        <sh-spinner size="m" overlay />
    }

    @if (!isLoading() && rows.length === 0) {
        <div class="table-no-items">
            <span>No items found</span>
        </div>
    }
</div>

@if (pagination()) {
    <sh-pagination
        pages="{{ totalPages }}"
        currentPage="{{ currentPage }}"
        (clickedPageMove)="onPageMove($event)"
        (nextPageMove)="onPageMove($event)"
        (previousPageMove)="onPageMove($event)"
    />
}
